import {BaseView} from '../core/view';
import constants from '../utils/constants';
import { ApiUtil } from '../utils/api-util';

export default BaseView.extend({

    // UI element references
    emailInput: null,
    nameInput: null,

    events: {
        "submit .js-newsletter-form": (e) => e.preventDefault(),
        'click .js-newsletter-submit': 'onSignupSubmit',
    },

    initialize: function () {
        this.emailInput = this.el.querySelector('.js-newsletter-email');
        this.nameInput  = this.el.querySelector('.js-newsletter-name');
    },

    onSignupSubmit: function (e) {
        
        let pattern = constants.EMAIL_REGEX;
        if (!pattern.test(this.emailInput.value)) {
            this.onSignupError();
            return;
        }

        this.el.classList.add('is-loading');
        
        let gender = this.el
            .querySelector('.js-newsletter-form')
            .getAttribute('data-gender');

        let data = {
            version: 2,
            email: this.emailInput.value,
            name: this.nameInput.value,
            isHomeAndLiving: !gender
        };

        ApiUtil.request({
            method: 'POST',
            data: data,
            path: constants.NEWSLETTER_SIGNUP_URL,
            success: (this.onSignupSuccess).bind(this),
            error: (this.onSignupError).bind(this)
        });
    },

    onSignupSuccess: function (data, status, xhr) {
        this.el.classList.add('success');
        this.el.classList.remove('is-loading');
        this.onSignupReset();
    },

    onSignupError: function (xhr, error, data) {
        this.el.classList.add('error');
        this.el.classList.remove('is-loading');
    },

    onSignupReset: function (e) {
        this.emailInput.value = '';
        this.nameInput.value = '';
        this.el.classList.remove('error');
    }
})